export enum EventCategory {
    FEATURE_USE = 'feature_use',
    UPDATER = 'updater',
    AGENTIC_HUB = 'agentic_hub',
    TMS_BILLING = 'tms_billing',
    TMS = 'tms',
    BOX_TRUCK = 'box_truck',
}

export enum AnalyticsEvent {
    // Updater events
    UPDATER_PAGE_VIEWED = 'updater_page_viewed',

    // Load detail page. Bounded enums and counts only: never load ids, document names or payroll amounts.
    LOAD_DETAIL_TAB_CHANGED = 'load_detail_tab_changed',
    LOAD_DETAIL_PAYROLL_MOVE_INITIATED = 'load_detail_payroll_move_initiated',
    LOAD_DETAIL_PAYROLL_MOVE_SUCCEEDED = 'load_detail_payroll_move_succeeded',
    LOAD_DETAIL_PAYROLL_MOVE_FAILED = 'load_detail_payroll_move_failed',
    LOAD_DETAIL_PAYROLL_MOVE_LOCKED = 'load_detail_payroll_move_locked',
    LOAD_DETAIL_STOP_TIMES_SAVE_SUCCEEDED = 'load_detail_stop_times_save_succeeded',
    LOAD_DETAIL_STOP_TIMES_SAVE_FAILED = 'load_detail_stop_times_save_failed',
    LOAD_DETAIL_DOCUMENTS_BULK_DOWNLOAD = 'load_detail_documents_bulk_download',

    UPDATER_LOAD_CREATED = 'updater_load_created',
    UPDATER_LOAD_STATUS_CHANGED = 'updater_load_status_changed',
    UPDATER_DOCUMENT_UPLOADED = 'updater_document_uploaded',
    UPDATER_EMAIL_SENT = 'updater_email_sent',

    // Manual action events for updater agent
    UPDATER_MANUAL_DRIVER_ASSIGN = 'updater_manual_driver_assign',
    UPDATER_PAPERWORK_UPLOADED = 'updater_paperwork_uploaded',
    UPDATER_MANUAL_BROKER_UPDATE = 'updater_manual_broker_update',
    UPDATER_MANUAL_STATUS_CHANGE = 'updater_manual_status_change',
    UPDATER_MANUAL_ETA_REFRESH = 'updater_manual_eta_refresh',
    UPDATER_MANUAL_LOAD_CREATION = 'updater_manual_load_creation',
    // Asked on save when the broker rate would change an invoice already issued: rewrite it, keep it, or cancel.
    UPDATER_INVOICE_RATE_DECISION = 'updater_invoice_rate_decision',
    // An Edit Load save the server refused (403) because the load sits on a locked or settled payroll statement.
    UPDATER_PAYROLL_LOCKED_SAVE_REJECTED = 'updater_payroll_locked_save_rejected',
    // Reassign on a COMPLETED load (Delivered tab): how the confirm step ended. It changes who is paid for a finished load.
    UPDATER_COMPLETED_LOAD_REASSIGN = 'updater_completed_load_reassign',
    // The pencil / info icon / "Set" control on a stop card in the shipment details was clicked to edit arrival & departure times.
    UPDATER_STOP_TIMES_EDIT_CLICKED = 'updater_stop_times_edit_clicked',
    UPDATER_STOP_DIRECTIONS_CLICKED = 'updater_stop_directions_clicked',
    // A dispatch sent from the dispatch message step: where the load ended up, whether a load in transit was kept
    // there, and whether the message reached the driver.
    UPDATER_LOAD_DISPATCHED = 'updater_load_dispatched',
    // A dispatch from the dispatch message step that the server refused or that failed (e.g. 409: the truck already
    // has a load in transit, or the load moved on since the step opened).
    UPDATER_LOAD_DISPATCH_FAILED = 'updater_load_dispatch_failed',

    // Generic action tracking
    ACTION = 'action',

    // Extension onboarding events
    EXTENSION_REQUIRED = 'extension_required',
    PRE_ONBOARDING_TAB_CLICKED = 'pre_onboarding_tab_clicked',
    SIGN_UP_STARTED = 'sign_up_started',
    SIGN_UP_FAILED = 'signup_failed',
    LOGIN_STARTED = 'login_started',
    LOGIN_SUCCESS = 'login_success',
    LOGIN_FAILED = 'login_failed',
    LOGOUT_SUCCESS = 'logout_success',
    RESEND_CLICKED = 'resend_clicked',
    FORGOT_PASSWORD_CODE_SENT = 'forgot_password_code_sent',
    FORGOT_PASSWORD_CODE_VERIFIED = 'forgot_password_code_verified',
    FORGOT_PASSWORD_RESET_SUCCESS = 'forgot_password_reset_success',
    FORGOT_PASSWORD_CODE_RESENT = 'forgot_password_code_resent',
    ONBOARDING_STEP = 'onboarding_step',
    TEMPLATE_UPDATED = 'template_updated',
    GET_STARTED_PAGE_VISIT = 'get_started_page_visit',
    LOGIN_PAGE_VISIT = 'login_page_visit',
    SIGN_UP_VERIFICATION_RESEND_CLICKED = 'sign_up_verification_resend_clicked',
    ONBOARDING_TEST_EMAIL_SENT = 'onboarding_test_email_sent',
    ONBOARDING_EMAIL_TEMPLATE_SAVED = 'onboarding_email_template_saved',
    EXTENSION_UNINSTALLED = 'extension_uninstalled',
    OPEN_DAT_ONE = 'open_dat_one',
    TO_MAIN_PAGE = 'to_main_page',

    // Canonical onboarding funnel events
    EXTENSION_INSTALLED = 'extension_installed',
    ONBOARDING_SIGNUP_STARTED = 'onboarding_signup_started',
    ONBOARDING_SIGNUP_COMPLETED = 'onboarding_signup_completed',
    ONBOARDING_VERIFICATION_SUCCESS = 'onboarding_verification_success',
    ONBOARDING_VERIFICATION_FAILED = 'onboarding_verification_failed',
    ONBOARDING_COMPANY_DETAILS_COMPLETED = 'onboarding_company_details_completed',
    ONBOARDING_COMPANY_DETAILS_SKIPPED = 'onboarding_company_details_skipped',
    ONBOARDING_EMAIL_CONNECT_STARTED = 'onboarding_email_connect_started',
    ONBOARDING_EMAIL_CONNECT_SUCCESS = 'onboarding_email_connect_success',
    ONBOARDING_EMAIL_CONNECT_SKIPPED = 'onboarding_email_connect_skipped',
    ONBOARDING_EMAIL_CONNECT_FAILED = 'onboarding_email_connect_failed',
    ONBOARDING_CHECKLIST_STEP_COMPLETED = 'onboarding_checklist_step_completed',
    ONBOARDING_COMPLETED = 'onboarding_completed',

    // /onboarding + /mobile-onboarding funnel — clean event set. Every event carries
    // `flow: 'onboarding' | 'mobile_onboarding'` so the desktop and mobile funnels can be
    // analyzed separately or together. ONBOARDING_STEP_VIEWED fires on every page mount.
    ONBOARDING_STEP_VIEWED = 'onboarding_step_viewed',
    ONBOARDING_RETURNING_USER_DETECTED = 'onboarding_returning_user_detected',
    ONBOARDING_OTP_SENT = 'onboarding_otp_sent',
    ONBOARDING_OTP_RESENT = 'onboarding_otp_resent',
    ONBOARDING_OTP_VERIFIED = 'onboarding_otp_verified',
    ONBOARDING_OTP_FAILED = 'onboarding_otp_failed',
    ONBOARDING_SIGNUP_FAILED = 'onboarding_signup_failed',
    ONBOARDING_LOGIN_STARTED = 'onboarding_login_started',
    ONBOARDING_LOGIN_SUCCEEDED = 'onboarding_login_succeeded',
    ONBOARDING_LOGIN_FAILED = 'onboarding_login_failed',
    ONBOARDING_FORGOT_PASSWORD_REQUESTED = 'onboarding_forgot_password_requested',
    ONBOARDING_FORGOT_PASSWORD_CODE_VERIFIED = 'onboarding_forgot_password_code_verified',
    ONBOARDING_FORGOT_PASSWORD_RESET = 'onboarding_forgot_password_reset',
    ONBOARDING_EXTENSION_INSTALL_CLICKED = 'onboarding_extension_install_clicked',
    ONBOARDING_EXTENSION_INSTALLED_DETECTED = 'onboarding_extension_installed_detected',
    ONBOARDING_EXTENSION_INSTALL_SKIPPED = 'onboarding_extension_install_skipped',
    ONBOARDING_EMAIL_TEMPLATE_SKIPPED = 'onboarding_email_template_skipped',

    // Load Hub events
    LOAD_HUB_SEARCH_CLICKED = 'load_hub_search_clicked',
    LOAD_HUB_EMAIL_SENT = 'load_hub_email_sent',
    LOAD_HUB_EMAIL_FAILED = 'load_hub_email_failed',
    LOAD_HUB_OFFER_EMAIL_SENT = 'load_hub_offer_email_sent',
    LOAD_HUB_OFFER_EMAIL_FAILED = 'load_hub_offer_email_failed',
    LOAD_HUB_BOOK_EMAIL_SENT = 'load_hub_book_email_sent',
    LOAD_HUB_BOOK_EMAIL_FAILED = 'load_hub_book_email_failed',
    LOAD_HUB_INFO_EMAIL_SENT = 'load_hub_info_email_sent',
    LOAD_HUB_INFO_EMAIL_FAILED = 'load_hub_info_email_failed',
    /** A loadboard source was connected from Load Hub. `loadboard` carries the board (TQL, BEON, …). */
    LOAD_HUB_SOURCE_CONNECTED = 'load_hub_source_connected',
    LOAD_HUB_PAGE_VIEWED = 'load_hub_page_viewed',
    LOAD_HUB_SOURCE_CONNECTION_STARTED = 'load_hub_source_connection_started',
    LOAD_HUB_SOURCE_CONNECTION_COMPLETED = 'load_hub_source_connection_completed',
    LOAD_HUB_SEARCH_SUBMITTED = 'load_hub_search_submitted',
    LOAD_HUB_SOURCE_SEARCH_COMPLETED = 'load_hub_source_search_completed',
    /** A board failed a search and the user was told why. `loadboard`, `error_code` (search catalogue code), `action`. */
    LOAD_HUB_SOURCE_ERROR_SHOWN = 'load_hub_source_error_shown',
    /** The user clicked the fix offered with a board failure (Reconnect). */
    LOAD_HUB_SOURCE_ERROR_ACTION_CLICKED = 'load_hub_source_error_action_clicked',
    LOAD_HUB_LOAD_INTERACTION = 'load_hub_load_interaction',
    LOAD_HUB_EMAIL_ATTEMPTED = 'load_hub_email_attempted',
    LOAD_HUB_EMAIL_COMPLETED = 'load_hub_email_completed',

    // Load Hub measurement contract v1. The emitter prefix is intentional: web
    // interaction events and server/extension operational events have different
    // activity and identity semantics in Amplitude.
    WEB_LOAD_HUB_VIEWED = 'web_load_hub_viewed',
    WEB_LOAD_HUB_SOURCES_CHANGED = 'web_load_hub_sources_changed',
    WEB_LOAD_HUB_CONNECTION_DIALOG_OPENED = 'web_load_hub_connection_dialog_opened',
    WEB_LOAD_HUB_CONNECTION_METHOD_SELECTED = 'web_load_hub_connection_method_selected',
    WEB_LOAD_HUB_CONNECTION_STARTED = 'web_load_hub_connection_started',
    WEB_LOAD_HUB_CONNECTION_STEP_RECORDED = 'web_load_hub_connection_step_recorded',
    EXT_LOAD_HUB_CONNECTION_STEP_RECORDED = 'ext_load_hub_connection_step_recorded',
    WEB_LOAD_HUB_CONNECTION_CANCELLED = 'web_load_hub_connection_cancelled',
    WEB_LOAD_HUB_SEARCH_BLOCKED = 'web_load_hub_search_blocked',
    WEB_LOAD_HUB_SEARCH_EXECUTION_STARTED = 'web_load_hub_search_execution_started',
    WEB_LOAD_HUB_SEARCH_EXECUTION_COMPLETED = 'web_load_hub_search_execution_completed',
    EXT_LOAD_HUB_SOURCE_SEARCH_STARTED = 'ext_load_hub_source_search_started',
    EXT_LOAD_HUB_SOURCE_SEARCH_COMPLETED = 'ext_load_hub_source_search_completed',
    WEB_LOAD_HUB_FILTERS_APPLIED = 'web_load_hub_filters_applied',
    WEB_LOAD_HUB_REFRESH_SETTINGS_CHANGED = 'web_load_hub_refresh_settings_changed',
    WEB_LOAD_HUB_REFRESH_SESSION_SUMMARY = 'web_load_hub_refresh_session_summary',
    WEB_LOAD_HUB_LOAD_DETAILS_OPENED = 'web_load_hub_load_details_opened',
    WEB_LOAD_HUB_LOAD_DETAILS_RESOLVED = 'web_load_hub_load_details_resolved',
    WEB_LOAD_HUB_RESULTS_SORT_CHANGED = 'web_load_hub_results_sort_changed',
    WEB_LOAD_HUB_CONTACT_CLICKED = 'web_load_hub_contact_clicked',
    WEB_LOAD_HUB_CONTACT_COPIED = 'web_load_hub_contact_copied',
    WEB_LOAD_HUB_EMAIL_COMPOSER_OPENED = 'web_load_hub_email_composer_opened',
    WEB_LOAD_HUB_EMAIL_SEND_SUBMITTED = 'web_load_hub_email_send_submitted',
    WEB_LOAD_HUB_EMAIL_REQUEST_FAILED = 'web_load_hub_email_request_failed',
    WEB_LOAD_HUB_CALL_HANDOFF_RESOLVED = 'web_load_hub_call_handoff_resolved',
    WEB_LOAD_HUB_UI_ACTION = 'web_load_hub_ui_action',

    // Load Radar events
    LOAD_RADAR_CREATED = 'load_radar_created',
    LOAD_RADAR_ERROR = 'load_radar_error',

    // Telegram Web App (TWA) Load Radar — guest growth funnel
    TWA_RADAR_OPENED = 'twa_radar_opened',
    TWA_RADAR_CREATED = 'twa_radar_created',
    TWA_RADAR_DELETED = 'twa_radar_deleted',
    TWA_RADAR_LIMIT_REACHED = 'twa_radar_limit_reached',
    TWA_RADAR_CONNECT_OPENED = 'twa_radar_connect_opened',
    TWA_RADAR_CONNECT_COMPLETED = 'twa_radar_connect_completed',
    TWA_ONBOARDING_LINK_SHOWN = 'twa_onboarding_link_shown',
    TWA_ONBOARDING_LINK_COPIED = 'twa_onboarding_link_copied',
    TWA_ONBOARDING_LINK_OPENED = 'twa_onboarding_link_opened',
    TWA_GUEST_MIGRATED = 'twa_guest_migrated',

    // Fuel AI events
    FUEL_AI_ROUTE_SEARCH = 'fuel_ai_route_search',
    FUEL_AI_TELEGRAM_SENT = 'fuel_ai_telegram_sent',
    FUEL_AI_COPY = 'fuel_ai_copy',
    FUEL_AI_PFC_CONNECT_STARTED = 'fuel_ai_pfc_connect_started',
    FUEL_AI_PFC_CONNECT_FAILED = 'fuel_ai_pfc_connect_failed',
    FUEL_AI_PFC_CONNECTED = 'fuel_ai_pfc_connected',
    FUEL_AI_PFC_SYNC_SUCCEEDED = 'fuel_ai_pfc_sync_succeeded',
    FUEL_AI_PFC_SYNC_FAILED = 'fuel_ai_pfc_sync_failed',
    FUEL_AI_PFC_ACTIVATION_FAILED = 'fuel_ai_pfc_activation_failed',
    FUEL_AI_PFC_DISCONNECTED = 'fuel_ai_pfc_disconnected',
    FUEL_AI_PFC_DISCONNECT_FAILED = 'fuel_ai_pfc_disconnect_failed',
    FUEL_AI_SOURCE_CONNECT_REQUESTED = 'fuel_ai_source_connect_requested',

    // Dispatcher Emails page events
    EMAILS_PAGE_VIEWED = 'emails_page_viewed',
    EMAILS_TAB_CHANGED = 'emails_tab_changed',
    EMAILS_SEARCH_PERFORMED = 'emails_search_performed',
    EMAILS_REFRESHED = 'emails_refreshed',
    EMAILS_THREAD_OPENED = 'emails_thread_opened',
    EMAILS_LOAD_MORE = 'emails_load_more',

    // Agentic Hub events — minimum viable set, all properties bounded enums/buckets
    AH_PAGE_VIEWED = 'ah_page_viewed',
    AH_SEARCH_SUBMITTED = 'ah_search_submitted',
    AH_SEARCH_COMPLETED = 'ah_search_completed',
    AH_SYNC_TRIGGERED = 'ah_sync_triggered',
    AH_LOAD_ACTION = 'ah_load_action',
    AH_AGENT_MESSAGE_SENT = 'ah_agent_message_sent',
    AH_AGENT_MODE_CHANGED = 'ah_agent_mode_changed',
    AH_QUESTION_RESPONDED = 'ah_question_responded',
    AH_MARKET_RPM_VIEWED = 'ah_market_rpm_viewed',
    AH_BROKER_STATUS_CHANGED = 'ah_broker_status_changed',
    AH_AGENT_PAUSED = 'ah_agent_paused',
    AH_BOOKING_HISTORY_OPENED = 'ah_booking_history_opened',
    AH_SOURCE_AUTH_REQUIRED = 'ah_source_auth_required',
    AH_SETUP_COMPLETED = 'ah_setup_completed',
    AH_ERROR = 'ah_error',
    AH_UI_INTERACTION = 'ah_ui_interaction',
    // Fired when a sent chat/search-agent message got no socket response within the ack
    // window and the HTTP fallback kicked in. Counts real-world socket delivery gaps;
    // slice by lane/outcome.
    AH_SOCKET_DROP_DETECTED = 'ah_socket_drop_detected',
    AH_SEARCH_STALL_DETECTED = 'ah_search_stall_detected',

    // Dashboard — P&L Report
    PL_REPORT_PAGE_VIEWED = 'pl_report_page_viewed',
    PL_REPORT_FILTER_CHANGED = 'pl_report_filter_changed',
    PL_REPORT_EXPORTED = 'pl_report_exported',

    // Dashboard — Task Management
    TASK_MGMT_PAGE_VIEWED = 'task_mgmt_page_viewed',
    TASK_MGMT_TASK_CREATED = 'task_mgmt_task_created',

    // Dashboard — Truck Availability Report
    TRUCK_AVAILABILITY_PAGE_VIEWED = 'truck_availability_page_viewed',

    // Load Management — boards
    UPDATE_BOARD_PAGE_VIEWED = 'update_board_page_viewed',
    DISPATCH_PLANNER_PAGE_VIEWED = 'dispatch_planner_page_viewed',
    DISPATCHER_LEADERBOARD_PAGE_VIEWED = 'dispatcher_leaderboard_page_viewed',
    DISPATCHER_LEADERBOARD_EXPORTED = 'dispatcher_leaderboard_exported',

    // Load Management — TMS import
    LOAD_TMS_IMPORT_INITIATED = 'load_tms_import_initiated',
    LOAD_TMS_IMPORT_COMPLETED = 'load_tms_import_completed',

    // Accounting — Invoices
    INVOICE_PAGE_VIEWED = 'invoice_page_viewed',
    INVOICE_PERIOD_FILTER_CHANGED = 'invoice_period_filter_changed',
    INVOICE_CREATED = 'invoice_created',
    INVOICE_SUBMITTED_TO_FACTORING = 'invoice_submitted_to_factoring',
    INVOICE_EMAIL_SENT = 'invoice_email_sent',
    INVOICE_BULK_UPDATED = 'invoice_bulk_updated',
    FACTORING_SUBMISSION_ATTEMPTED = 'factoring_submission_attempted',
    // The "confirm which company you are submitting as" gate. SHOWN vs CONFIRMED gives both the
    // friction this gate adds and how often a dispatcher backs out once they read the company.
    FACTORING_COMPANY_GATE_SHOWN = 'factoring_company_gate_shown',
    FACTORING_COMPANY_GATE_CONFIRMED = 'factoring_company_gate_confirmed',
    // Internal notes — count only, never the note text (PII / free-text rule).
    INVOICE_NOTE_ADDED = 'invoice_note_added',

    // Accounting — Payroll
    DRIVER_PAY_PAGE_VIEWED = 'driver_pay_page_viewed',
    DRIVER_STATEMENT_GENERATED = 'driver_statement_generated',
    DRIVER_STATEMENT_SENT = 'driver_statement_sent',
    DRIVER_STATEMENT_LOCK_UNLOCK = 'driver_statement_lock_unlock',
    DRIVER_STATEMENT_BULK_GENERATED = 'driver_statement_bulk_generated',
    // Company setting behind every driver and contractor statement PDF: `mode` (summary | detailed), `context`, `outcome`.
    FUEL_TOLL_DISPLAY_SAVED = 'fuel_toll_display_saved',
    // A fuel/toll provider file refused at upload: `provider`, `category`, `outcome` (missing_columns | unrecognized | empty), `missing_columns`.
    FUEL_TOLL_IMPORT_REFUSED = 'fuel_toll_import_refused',
    // How a Confirm & Charge ended: `outcome` (applied | partial | failed | nothing_new | error), bounded counts, `via_move_and_charge`.
    FUEL_TOLL_CHARGE_OUTCOME = 'fuel_toll_charge_outcome',
    // The closed-period decision in the preview: `action` (gate_opened | gate_dismissed | move_and_charge | inline_move | inline_move_undone), `group_count`.
    FUEL_TOLL_CLOSED_PERIOD_ACTION = 'fuel_toll_closed_period_action',
    // The header "Consolidate split drivers" switch: `enabled`, `row_count`.
    FUEL_TOLL_STRAY_MOVE_TOGGLED = 'fuel_toll_stray_move_toggled',
    // The preview's period tab bar: `target` (all | period), `source` (tab | chip).
    FUEL_TOLL_PERIOD_TAB_CHANGED = 'fuel_toll_period_tab_changed',
    // The %/$ unit beside a fuel discount: `surface` (inline_add | edit_modal), `from`, `to` (percent | amount).
    FUEL_DISCOUNT_MODE_CHANGED = 'fuel_discount_mode_changed',
    // A fuel charge added inline or edited in the modal: `surface`, `discount_mode`, `outcome` (success | failure).
    FUEL_CHARGE_SAVE_OUTCOME = 'fuel_charge_save_outcome',
    // The accounting settings saved from the invoice settings modal: `outcome` (success | failure), `reminders_enabled`, `sender_chosen`, `locked_reason`
    // (none | no_factoring | england_missing | sender_problem).
    INVOICE_REMINDER_SETTINGS_SAVE_OUTCOME = 'invoice_reminder_settings_save_outcome',
    CONTRACTOR_PAY_PAGE_VIEWED = 'contractor_pay_page_viewed',
    CONTRACTOR_STATEMENT_GENERATED = 'contractor_statement_generated',
    CONTRACTOR_STATEMENT_SENT = 'contractor_statement_sent',
    CONTRACTOR_STATEMENT_LOCK_UNLOCK = 'contractor_statement_lock_unlock',
    CONTRACTOR_STATEMENT_BULK_GENERATED = 'contractor_statement_bulk_generated',
    // label: 'per_truck' | 'combined' — the company-wide switch that decides how every contractor statement is grouped.
    CONTRACTOR_STATEMENT_GROUPING_CHANGED = 'contractor_statement_grouping_changed',
    // label: 'payout' | 'gross' — the company-wide setting for how a contractor statement's driver-salary deduction is computed.
    CONTRACTOR_STATEMENT_DRIVER_SALARY_BASIS_CHANGED = 'contractor_statement_driver_salary_basis_changed',
    // label: 'rejected' (server said no) | 'error' (request failed). Success is CONTRACTOR_STATEMENT_GENERATED.
    CONTRACTOR_STATEMENT_GENERATION_FAILED = 'contractor_statement_generation_failed',
    // A truck picked on a pay adjustment (attribution to a truck statement). label: 'driver' | 'contractor' | 'unassigned'.
    PAY_ADJUSTMENT_TRUCK_SELECTED = 'pay_adjustment_truck_selected',

    // Accounting — Invoice Aging / Disputes
    INVOICE_AGING_PAGE_VIEWED = 'invoice_aging_page_viewed',

    // Accounting — Finance Verify (AI BoL/POD)
    FINANCE_VERIFY_PAGE_VIEWED = 'finance_verify_page_viewed',
    PAPERWORK_VERIFICATION_STARTED = 'paperwork_verification_started',
    PAPERWORK_VERIFICATION_COMPLETED = 'paperwork_verification_completed',

    // Fleet — Map
    FLEET_MAP_PAGE_VIEWED = 'fleet_map_page_viewed',

    // Fleet — Maintenance / Work Orders
    MAINTENANCE_AI_ABSTRACTED = 'maintenance_ai_abstracted',
    WORK_ORDER_CREATED = 'work_order_created',
    WORK_ORDER_COMPLETED = 'work_order_completed',
    WORK_ORDER_PAID_DATE_APPLIED = 'work_order_paid_date_applied',

    // Fleet — ELD Connections
    ELD_CONNECTION_ATTEMPTED = 'eld_connection_attempted',
    ELD_CONNECTION_SUCCEEDED = 'eld_connection_succeeded',

    // Fleet — Compliance
    FLEET_COMPLIANCE_PAGE_VIEWED = 'fleet_compliance_page_viewed',
    COMPLIANCE_RECORD_SAVED = 'compliance_record_saved',

    // Fleet — DVIR
    DVIR_PAGE_VIEWED = 'dvir_page_viewed',
    DVIR_SUBMITTED = 'dvir_submitted',

    // Safety — Documents
    SAFETY_DOCS_PAGE_VIEWED = 'safety_docs_page_viewed',
    SAFETY_DOC_ABSTRACTED = 'safety_doc_abstracted',

    // Safety — IFTA
    IFTA_PAGE_VIEWED = 'ifta_page_viewed',
    IFTA_REPORT_GENERATED = 'ifta_report_generated',
    IFTA_REPORT_EXPORTED = 'ifta_report_exported',

    // Safety — Claims
    CLAIMS_PAGE_VIEWED = 'claims_page_viewed',

    // Reports
    REPORTS_PAGE_VIEWED = 'reports_page_viewed',
    REPORTS_TAB_SWITCHED = 'reports_tab_switched',

    // Integrations
    QUICKBOOKS_PAGE_VIEWED = 'quickbooks_page_viewed',
    TOLL_FUEL_PAGE_VIEWED = 'toll_fuel_page_viewed',
    TOLL_FUEL_CONNECTED = 'toll_fuel_connected',

    // Settings — carrier MC verification. Every event carries `method` (email / documents / migration)
    // and `step`, so the funnel can be sliced by which path the carrier took; succeeded/failed carry
    // `outcome` + `result_status` so one chart over both answers "how did it end".
    MC_VERIFICATION_FLOW_OPENED = 'mc_verification_flow_opened',
    MC_VERIFICATION_ATTEMPTED = 'mc_verification_attempted',
    MC_VERIFICATION_SUCCEEDED = 'mc_verification_succeeded',
    MC_VERIFICATION_FAILED = 'mc_verification_failed',

    // Asset Management
    TRUCK_MGMT_PAGE_VIEWED = 'truck_mgmt_page_viewed',
    TRAILER_MGMT_PAGE_VIEWED = 'trailer_mgmt_page_viewed',

    // Accounting — 1099 Reports
    TAX_1099_PAGE_VIEWED = 'tax_1099_page_viewed',
    TAX_1099_EXPORTED = 'tax_1099_exported',
    TAX_1099_YEAR_CHANGED = 'tax_1099_year_changed',

    // Numeo One TMS billing page (ADR-020)
    TMS_BILLING_TAB_VIEWED = 'tms_billing_tab_viewed',
    TMS_BILLING_MANAGE_CLICKED = 'tms_billing_manage_clicked',
    TMS_BILLING_INTERVAL_CHANGED = 'tms_billing_interval_changed',
    TMS_BILLING_CTA_CLICKED = 'tms_billing_cta_clicked',
    TMS_BILLING_TALK_TO_SALES = 'tms_billing_talk_to_sales',
    TMS_BILLING_PLAN_DETAILS_SCROLLED = 'tms_billing_plan_details_scrolled',
    TMS_BILLING_TRUCKS_CHANGED = 'tms_billing_trucks_changed',
    TMS_BILLING_CHECKOUT_SUCCESS = 'tms_billing_checkout_success',
    TMS_BILLING_CHECKOUT_CANCELED = 'tms_billing_checkout_canceled',
    TMS_CHECKOUT_STARTED = 'tms_checkout_started',

    // One event per tenant that gains TMS access from the auth screen, whether it registered there
    // (`activation_type: 'signup'`) or was an existing account crossed over into TMS
    // (`activation_type: 'crossover'`). Crossovers create no new account, so they fire no signup
    // event and were invisible — yet they receive the same 14-day trial. Deliberately NOT a funnel
    // event: `signup_completed` feeds GA4/Meta/Google Ads, and counting an existing customer there
    // would corrupt ad optimization.
    TMS_ACCOUNT_ACTIVATED = 'tms_account_activated',

    // TMS page-view coverage (TMS event tracking proposal). Fleet Overview intentionally has no
    // tms_ event — the existing fleet_map_page_viewed already fires on /fleet/overview.
    BILLING_PAGE_VIEWED = 'billing_page_viewed', // shared page, both products — no tms_ prefix
    TMS_SETTINGS_PAGE_VIEWED = 'tms_settings_page_viewed',
    TMS_TRUCK_PL_PAGE_VIEWED = 'tms_truck_pl_page_viewed',
    TMS_MARKET_INTEL_PAGE_VIEWED = 'tms_market_intel_page_viewed',
    TMS_EXPENSES_PAGE_VIEWED = 'tms_expenses_page_viewed',
    TMS_PREPAYMENTS_PAGE_VIEWED = 'tms_prepayments_page_viewed',
    TMS_PAY_ADJUSTMENTS_PAGE_VIEWED = 'tms_pay_adjustments_page_viewed',
    TMS_FACTORING_PAGE_VIEWED = 'tms_factoring_page_viewed',
    TMS_BROKER_PERFORMANCE_PAGE_VIEWED = 'tms_broker_performance_page_viewed',
    TMS_MAINTENANCE_PAGE_VIEWED = 'tms_maintenance_page_viewed',
    TMS_FUEL_AI_PAGE_VIEWED = 'tms_fuel_ai_page_viewed',
    TMS_SAFETY_DASHBOARD_PAGE_VIEWED = 'tms_safety_dashboard_page_viewed',
    TMS_DRIVER_COMPLIANCE_PAGE_VIEWED = 'tms_driver_compliance_page_viewed',
    TMS_DOT_INSPECTIONS_PAGE_VIEWED = 'tms_dot_inspections_page_viewed',
    TMS_DRUG_ALCOHOL_PAGE_VIEWED = 'tms_drug_alcohol_page_viewed',
    TMS_DRIVERS_PAGE_VIEWED = 'tms_drivers_page_viewed',
    TMS_CONTRACTORS_PAGE_VIEWED = 'tms_contractors_page_viewed',
    TMS_BROKERS_PAGE_VIEWED = 'tms_brokers_page_viewed',

    // TMS growth / activation events
    REFERRAL_PROMO_CLICKED = 'referral_promo_clicked', // shared sidebar — no tms_ prefix
    UPGRADE_LIMIT_HIT_VIEWED = 'upgrade_limit_hit_viewed', // shared limit gate — no tms_ prefix
    TMS_INTEGRATION_CONNECT_CLICKED = 'tms_integration_connect_clicked',
    TMS_INTEGRATION_CREDENTIALS_SAVED = 'tms_integration_credentials_saved',
    /** The connect flow's account step (look the accounts up, choose one, or go back), with a `step` and an `outcome`. */
    TMS_INTEGRATION_ACCOUNT_STEP = 'tms_integration_account_step',
    TMS_TEAMMATE_INVITE_SENT = 'tms_teammate_invite_sent',
    TMS_DRIVER_ADDED = 'tms_driver_added',
    /** Add Driver met an email that already has an account: a Box Truck roster invite, not an add. */
    BOX_TRUCK_ROSTER_INVITED = 'box_truck_roster_invited',
    BOX_TRUCK_ROSTER_INVITE_FAILED = 'box_truck_roster_invite_failed',
    TMS_DRIVER_APP_INVITE_SENT = 'tms_driver_app_invite_sent',
    TMS_DRIVER_APP_INVITE_FAILED = 'tms_driver_app_invite_failed',
    TMS_AI_ACTION_REVIEWED = 'tms_ai_action_reviewed',

    // TMS module action events
    TMS_INCIDENT_REPORTED = 'tms_incident_reported',
    TMS_DOT_INSPECTION_LOGGED = 'tms_dot_inspection_logged',
    TMS_DATAQS_CHALLENGE_CREATED = 'tms_dataqs_challenge_created',
    TMS_TEST_RESULT_RECORDED = 'tms_test_result_recorded',
    TMS_DQF_EXPORTED = 'tms_dqf_exported',
    TMS_BROKER_ADDED = 'tms_broker_added',
    // Broker search is server-side and paged; these show how often it's used and from where.
    BROKER_SEARCH_PERFORMED = 'broker_search_performed',
    BROKER_SEARCH_RESULT_SELECTED = 'broker_search_result_selected',
    TMS_BROKERS_PAGE_CHANGED = 'tms_brokers_page_changed',
    TMS_BROKERS_FILTER_CHANGED = 'tms_brokers_filter_changed',
    TMS_CONTRACTOR_ADDED = 'tms_contractor_added',
    TMS_TRUCK_ADDED = 'tms_truck_added',
    // An edit save that changed a truck's ownership type (Company / Owner Operator / Leased / Rental / none).
    // Only on an actual change, with `outcome` saved / failed, so Rental adoption is measurable.
    TMS_TRUCK_OWNERSHIP_CHANGED = 'tms_truck_ownership_changed',
    // Batch detail statement filters — one event per filter change, sent once its result arrives so it
    // carries the outcome count (how often a combination comes back empty).
    TMS_BATCH_STATEMENTS_FILTERED = 'tms_batch_statements_filtered',
    TMS_BATCH_STATEMENT_DELETED = 'tms_batch_statement_deleted',
    // A column-header sort click on the Driver Pay table: `column` is the column key, `direction` the order it now has
    // (asc | desc), `surface` is period | batch-detail | contractor-period, so adoption and the popular columns are both visible.
    TMS_DRIVER_PAY_SORT_CHANGED = 'tms_driver_pay_sort_changed',
    TMS_PM_SCHEDULE_ADDED = 'tms_pm_schedule_added',
    // The PM Schedules date range changed: `date_basis` is createdDate | lastPmDate, `has_date_range` is false when the range was cleared.
    TMS_PM_SCHEDULE_DATE_FILTERED = 'tms_pm_schedule_date_filtered',
    // Fleet ownership filter (Compliance + Maintenance): `surface` says which page (compliance | maintenance | maintenance_pm), `categories` the applied
    // selection (a fixed enum), so adoption and the popular combinations are both visible. `categories` values: ownerOperator | companyTruck |
    // rentalTruck | leasedTruck | notSet | trailer. leasedTruck and notSet are new, and from that release companyTruck no longer includes
    // leased trucks or trucks with no ownership type.
    TMS_FLEET_OWNERSHIP_FILTERED = 'tms_fleet_ownership_filtered',
    // Compliance "Export Report": `filtered` + the exported vs total alert counts tell a narrowed export
    // apart from a full one.
    TMS_COMPLIANCE_REPORT_EXPORTED = 'tms_compliance_report_exported',
    TMS_INSPECTION_LOGGED = 'tms_inspection_logged',
    // Void/restore on Fleet DVIRs and Safety DOT inspections. `deleted`/`restored` give adoption,
    // `delete_blocked` gives how often the open-defect / open-work-order / open-status guards actually
    // fire. The deletion REASON deliberately stays out of Amplitude — it is operator free text that can
    // name people, and it is already recorded on the record itself in `statusHistory`.
    TMS_INSPECTION_DELETED = 'tms_inspection_deleted',
    TMS_INSPECTION_RESTORED = 'tms_inspection_restored',
    // Attach or remove of the one file on a saved DVIR or DOT inspection. `scope` + `action` + `outcome`
    // are closed sets; file names and ids deliberately stay out of Amplitude.
    TMS_INSPECTION_ATTACHMENT_CHANGED = 'tms_inspection_attachment_changed',
    TMS_INSPECTION_ATTACHMENT_DOWNLOADED = 'tms_inspection_attachment_downloaded',
    TMS_INSPECTION_DELETE_BLOCKED = 'tms_inspection_delete_blocked',
    // Restore has its own failure event rather than sharing the delete one: a restore that fails is
    // usually a stale Archived row someone else already restored (409), which is a different story from
    // a delete the guards refused. Without it, only one half of the workflow reports its failures.
    TMS_INSPECTION_RESTORE_FAILED = 'tms_inspection_restore_failed',
    TMS_TASK_EMAIL_BROKER_CLICKED = 'tms_task_email_broker_clicked',

    // TMS accounting / asset action events (proposal §2D, P1)
    TMS_EXPENSE_ADDED = 'tms_expense_added',
    TMS_PREPAYMENT_ADDED = 'tms_prepayment_added',
    // One per Bulk Add submit, not one TMS_PREPAYMENT_ADDED per row: a 100-row batch must not read as 100 single adds.
    TMS_PREPAYMENT_BULK_SUBMITTED = 'tms_prepayment_bulk_submitted',
    TMS_FACTORING_REPORT_EXPORTED = 'tms_factoring_report_exported',
    TMS_TRUCK_PL_EXPORTED = 'tms_truck_pl_exported',
    TMS_ELD_SYNC_TRIGGERED = 'tms_eld_sync_triggered',
    TMS_AUTO_SYNC_TOGGLED = 'tms_auto_sync_toggled',
    // Deliberately not TMS_AUTO_SYNC_TOGGLED: reusing it would count every frequency change as another
    // "enabled" and inflate the existing on/off funnel.
    TMS_AUTO_SYNC_FREQUENCY_CHANGED = 'tms_auto_sync_frequency_changed',

    // Market Intel heat map (ADR-033 J2): which filters dispatchers rely on and whether they drill into an area.
    TMS_MARKET_INTEL_FILTER_CHANGED = 'tms_market_intel_filter_changed',
    TMS_MARKET_INTEL_AREA_OPENED = 'tms_market_intel_area_opened',
    /** One per area opened: `outcome` is loaded / empty / failed, so a broken drill-down shows up as failures, not silence. */
    TMS_MARKET_INTEL_DESTINATIONS_LOADED = 'tms_market_intel_destinations_loaded',
    /** One per area opened outbound: whether "Book now" found live loads (loaded / empty / failed). */
    TMS_MARKET_INTEL_TOP_LOADS_LOADED = 'tms_market_intel_top_loads_loaded',

    // Box Truck loadboard events
    BOX_TRUCK_PAGE_VIEWED = 'box_truck_page_viewed',
    BOX_TRUCK_SEARCH_SUBMITTED = 'box_truck_search_submitted',
    /** A list of ZIPs was pasted into the Origin field and added in one press. Counts only — a ZIP is
     *  where a carrier's truck is, and the aggregate question is how many, not which. */
    BOX_TRUCK_ZIP_LIST_ADDED = 'box_truck_zip_list_added',
    BOX_TRUCK_LOAD_OPENED = 'box_truck_load_opened',
    BOX_TRUCK_EMAIL_SENT = 'box_truck_email_sent',
    BOX_TRUCK_RATING_SET = 'box_truck_rating_set',
    BOX_TRUCK_NOTE_SAVED = 'box_truck_note_saved',
    /** Smaller UI controls (bid-loads toggle, auto-refresh, source chip, copy load, map, refresh, equipment);
     *  group by `element`. */
    BOX_TRUCK_UI_INTERACTION = 'box_truck_ui_interaction',

    // Box Truck Dispatcher Analytics (admin-only). Deliberately bounded properties: a preset key or the
    // window length in days, never the raw dates, and never the table's search text.
    BOX_TRUCK_ANALYTICS_VIEWED = 'box_truck_analytics_viewed',
    BOX_TRUCK_ANALYTICS_RANGE_CHANGED = 'box_truck_analytics_range_changed',
    BOX_TRUCK_ANALYTICS_LOADED = 'box_truck_analytics_loaded',
    BOX_TRUCK_ANALYTICS_EXPORTED = 'box_truck_analytics_exported',

    // Saving Box Truck profile fields from Profiles. `method` separates the two outcomes that matter:
    // `create` ADOPTS a driver into Box Truck (a state transition — the driver becomes visible to the board,
    // the bid flow and the driver app), `patch` only edits one that was already there. Bounded to those two
    // values; the driver is never identified.
    // Revealing a stored bank number in full. The server keeps a security audit record of every one; these
    // are the product counterpart — how often the control is used, and how often it fails. Bounded to which
    // ENTITY and which FIELD; the number itself never goes near an event.
    BOX_TRUCK_BANK_REVEALED = 'box_truck_bank_revealed',
    BOX_TRUCK_BANK_REVEAL_FAILED = 'box_truck_bank_reveal_failed',
    BOX_TRUCK_DRIVER_DETAILS_SAVED = 'box_truck_driver_details_saved',
    BOX_TRUCK_DRIVER_DETAILS_SAVE_FAILED = 'box_truck_driver_details_save_failed',
    /** Explicit Add Driver section navigation, not automatic scroll tracking. */
    BOX_TRUCK_DRIVER_PROFILE_SECTION_SELECTED = 'box_truck_driver_profile_section_selected',
    BOX_TRUCK_VEHICLE_DETAILS_SAVED = 'box_truck_vehicle_details_saved',
    BOX_TRUCK_VEHICLE_DETAILS_SAVE_FAILED = 'box_truck_vehicle_details_save_failed',
    /** The vehicle modal opened: which `form` (whole editor, Quick Add Truck, or the editor from a driver's profile) and
     *  whether it creates or edits. `outcome: not_found` is a driver's vehicle that could not be opened at all. */
    BOX_TRUCK_VEHICLE_FORM_OPENED = 'box_truck_vehicle_form_opened',
    /** The vehicle modal closed without saving — Cancel, ✕ or Escape. Read against OPENED and SAVED for abandonment. */
    BOX_TRUCK_VEHICLE_FORM_CANCELLED = 'box_truck_vehicle_form_cancelled',
    BOX_TRUCK_PROFILE_DOCUMENT_UPLOAD = 'box_truck_profile_document_upload',
    BOX_TRUCK_PROFILE_DOCUMENT_REMOVAL = 'box_truck_profile_document_removal',
    // AI autofill of a profile form from its documents. READ is one file's read: the document type, what the model read it as and the
    // NAMES of the fields it returned (never their values). APPLIED is a card's result in the form. ACTION is HR starting, cancelling
    // or retrying a read, or using a document's value.
    BOX_TRUCK_PROFILE_DOCUMENT_AUTOFILL_READ = 'box_truck_profile_document_autofill_read',
    BOX_TRUCK_PROFILE_DOCUMENT_AUTOFILL_APPLIED = 'box_truck_profile_document_autofill_applied',
    BOX_TRUCK_PROFILE_DOCUMENT_AUTOFILL_ACTION = 'box_truck_profile_document_autofill_action',
    // Flipping a driver's box-truck status from the Profiles table. `to` is the status chosen — the three
    // bounded values, no driver identity. Worth its own event because the status gates BIDDING: a run of
    // `inactive` is an operator taking drivers off the board, which no other signal shows.
    // Creating a driver and their carrier in one pass from Add Driver. The setup is several writes, so the
    // failure event names the STAGE that broke rather than collapsing them into one rate.
    BOX_TRUCK_OWNER_OPERATOR_CREATION_STARTED = 'box_truck_owner_operator_creation_started',
    BOX_TRUCK_OWNER_OPERATOR_CREATION_SUCCEEDED = 'box_truck_owner_operator_creation_succeeded',
    BOX_TRUCK_OWNER_OPERATOR_CREATION_FAILED = 'box_truck_owner_operator_creation_failed',
    SCHEDULER_STATUS_ORDER_CHANGED = 'scheduler_status_order_changed',
    SCHEDULER_DRIVER_STATUS_MUTATED = 'scheduler_driver_status_mutated',
    SCHEDULER_DRIVER_READY_SELECTED = 'scheduler_driver_ready_selected',
    BOX_TRUCK_DRIVER_STATUS_CHANGED = 'box_truck_driver_status_changed',
    BOX_TRUCK_DRIVER_STATUS_CHANGE_FAILED = 'box_truck_driver_status_change_failed',
    // An existing driver's owner changed from the driver form, which MOVES them to that owner. The failure's
    // `reason` adds `not_found` to the shared buckets: the driver or owner is not visible to the caller —
    // e.g. a Groups change in the same save took the driver out of their scope.
    BOX_TRUCK_DRIVER_OWNER_CHANGED = 'box_truck_driver_owner_changed',
    BOX_TRUCK_DRIVER_OWNER_CHANGE_FAILED = 'box_truck_driver_owner_change_failed',

    // Groups (ADR-027) — Settings → Groups. Domain-neutral on purpose: Box Truck is the first consumer,
    // TMS is the next. Counts and deltas only; see the helper for why no member identity travels.
    TEAM_GROUP_MEMBERS_SAVED = 'team_group_members_saved',
    /** A Dispatch Manager was promoted or demoted — the permission-granting half of the same Save. */
    TEAM_GROUP_MANAGERS_CHANGED = 'team_group_managers_changed',

    // Giving an owner a driver or vehicle that already exists. `reassigned` is the part worth watching:
    // taking one that already belonged to another carrier is a different act from picking up a free one,
    // and the picker deliberately allows both. The failure twin carries how many landed before it stopped,
    // because a round that fails halfway still moved records. Bounded to the entity kind and bucketed
    // counts; neither the record nor either owner is ever identified.
    BOX_TRUCK_OWNER_LINKED = 'box_truck_owner_linked',
    BOX_TRUCK_OWNER_LINK_FAILED = 'box_truck_owner_link_failed',

    // Merged statements ZIP (Driver Pay, Contractor Pay). Bounded properties only: the statement kind, a count, the ZIP size in bytes and the failure bucket.
    MERGED_STATEMENTS_EXPORT_STARTED = 'merged_statements_export_started',
    MERGED_STATEMENTS_EXPORT_SUCCEEDED = 'merged_statements_export_succeeded',
    MERGED_STATEMENTS_EXPORT_FAILED = 'merged_statements_export_failed',
    MERGED_STATEMENTS_EXPORT_CANCELLED = 'merged_statements_export_cancelled',

    // Excel report exports (Trips, Invoices, Payroll). Bounded properties only: the report kind, the tab, whether filters were applied and the failure bucket.
    REPORT_EXPORT_STARTED = 'report_export_started',
    REPORT_EXPORT_SUCCEEDED = 'report_export_succeeded',
    REPORT_EXPORT_FAILED = 'report_export_failed',

    // Load tags. Counts and enums only: load ids, tag ids, tag names and emoji are never sent.
    LOAD_TAG_CREATED = 'load_tag_created',
    LOAD_TAG_UPDATED = 'load_tag_updated',
    LOAD_TAG_DELETED = 'load_tag_deleted',
    LOAD_TAGS_PICKER_OPENED = 'load_tags_picker_opened',
    LOAD_TAGS_SAVED = 'load_tags_saved',
    LOAD_TAGS_BULK_SAVED = 'load_tags_bulk_saved',
    LOAD_TAGS_PICKER_CANCELLED = 'load_tags_picker_cancelled',
    LOAD_TAGS_MANAGE_CLICKED = 'load_tags_manage_clicked',
    LOAD_TAGS_FILTER_CHANGED = 'load_tags_filter_changed',

    // Notes of a load or a driver (Overview card, Update Board cell, notes panel). Bounded properties only: where it happened, whose notes,
    // the priority (or none), the sort order, delete trigger and outcome. Note text and ids are never sent.
    NOTES_PANEL_OPENED = 'notes_panel_opened',
    NOTE_CREATED = 'note_created',
    NOTE_DELETED = 'note_deleted',
    NOTE_PRIORITY_CHANGED = 'note_priority_changed',
    NOTE_PRIORITY_FILTERED = 'note_priority_filtered',
    NOTES_SORT_TOGGLED = 'notes_sort_toggled',

    // Batch/Period (where a load is paid). Counts and bounded enums only: never batch, statement or load ids.
    PAYROLL_BATCH_FILTER_CHANGED = 'payroll_batch_filter_changed',
    PAYROLL_PLACEMENT_OPENED = 'payroll_placement_opened',
    BATCH_PERIOD_COLUMN_TOGGLED = 'batch_period_column_toggled',

    // All Trips date range filter: the popover's outcome and which boundaries it carries. Never the dates themselves.
    TRIP_DATE_FILTER_CHANGED = 'trip_date_filter_changed',

    // Fuel AI Route Suggestion History order picked from its headers: the bounded sort key only.
    FUEL_AI_HISTORY_SORT_CHANGED = 'fuel_ai_history_sort_changed',

    // Contractor Profiles actions. Outcomes are bounded; document names and record IDs are never sent.
    BOX_TRUCK_CONTRACTOR_DOCUMENT_UPLOAD = 'box_truck_contractor_document_upload',
    BOX_TRUCK_CONTRACTOR_DOCUMENT_REMOVAL = 'box_truck_contractor_document_removal',
    BOX_TRUCK_CONTRACTOR_STATUS_CHANGE = 'box_truck_contractor_status_change',
    BOX_TRUCK_CONTRACTOR_DRIVER_QUICK_ADD = 'box_truck_contractor_driver_quick_add',
    BOX_TRUCK_OWNER_QUICK_ADD = 'box_truck_owner_quick_add',

    // SMS over the tenant's own Quo line (ADR-043). Configuration and sending, both of which cost the
    // company money and decide which number a driver sees. Never the API key, a phone number, a message
    // body, or a driver id — outcomes and counts only.
    BOX_TRUCK_QUO_CONNECTED = 'box_truck_quo_connected',
    BOX_TRUCK_QUO_CONNECT_FAILED = 'box_truck_quo_connect_failed',
    BOX_TRUCK_QUO_DISCONNECTED = 'box_truck_quo_disconnected',
    BOX_TRUCK_QUO_WEBHOOK_RETRIED = 'box_truck_quo_webhook_retried',
    BOX_TRUCK_QUO_ROUTING_SAVED = 'box_truck_quo_routing_saved',
    BOX_TRUCK_QUO_ROUTING_SAVE_FAILED = 'box_truck_quo_routing_save_failed',
    BOX_TRUCK_SMS_SENT = 'box_truck_sms_sent',
    /** The load drawer's SMS panel was opened for a driver — reading a thread is a use of its own. */
    BOX_TRUCK_SMS_CHAT_OPENED = 'box_truck_sms_chat_opened',
    /** The drawer's panel was switched to another of a driver's conversations. */
    BOX_TRUCK_SMS_LINE_SWITCHED = 'box_truck_sms_line_switched',
    /** An attachment in a thread would not load — the signal for whether vendor links expire. */
    BOX_TRUCK_SMS_ATTACHMENT_FAILED = 'box_truck_sms_attachment_failed',
    BOX_TRUCK_SMS_SEND_FAILED = 'box_truck_sms_send_failed',
    /**
     * The load bot was switched on or off (ADR-057 §14) — for one conversation, or for the whole company.
     *
     * Both scopes on one event, told apart by `scope`: the question is the same one ("does a dispatcher
     * trust it to answer their drivers"), and two events would need every chart asked twice. The company
     * scope is the one that must be measured — it silences the bot for every driver at once — so `on` and
     * `outcome` are always present.
     */
    BOX_TRUCK_OFFER_BOT_TOGGLED = 'box_truck_offer_bot_toggled',
    BOX_TRUCK_SEE_ALL_DRIVERS_CHANGED = 'box_truck_see_all_drivers_changed',
    BOX_TRUCK_MAILING_SERVICE_CHOSEN = 'box_truck_mailing_service_chosen',

    // Box Truck agreement signing: the agreement in Settings, its fields, and the signing links HR creates. Outcomes,
    // entry points, the recipient kind and counts only; file names, link tokens, names and record ids are never sent.
    // The public signing page sends nothing: its address is the link itself.
    BOX_TRUCK_AGREEMENT_UPLOADED = 'box_truck_agreement_uploaded',
    BOX_TRUCK_AGREEMENT_DELETED = 'box_truck_agreement_deleted',
    BOX_TRUCK_AGREEMENT_FIELDS_SAVED = 'box_truck_agreement_fields_saved',
    BOX_TRUCK_AGREEMENT_FIELDS_CLOSED = 'box_truck_agreement_fields_closed',
    BOX_TRUCK_AGREEMENT_LINK_CREATED = 'box_truck_agreement_link_created',
    /** HR created a driver sign-in link for the mobile app. Properties: outcome (succeeded | failed), reason (refused | error) on failure. */
    BOX_TRUCK_DRIVER_APP_LINK_CREATED = 'box_truck_driver_app_link_created',
    BOX_TRUCK_AGREEMENT_SIGNED_OPENED = 'box_truck_agreement_signed_opened',

    // Public shared-load funnel. Properties are bounded; never include tokens,
    // load IDs, broker contact information, or other link-holder data.
    SHARED_LOAD_PAGE_VIEWED = 'shared_load_page_viewed',
    SHARED_LOAD_PAGE_FAILED = 'shared_load_page_failed',
    SHARED_LOAD_CONTACT_CLICKED = 'shared_load_contact_clicked',
    SHARED_LOAD_INSTALL_BANNER_VIEWED = 'shared_load_install_banner_viewed',
    SHARED_LOAD_INSTALL_BANNER_CLICKED = 'shared_load_install_banner_clicked',
    SHARED_LOAD_INSTALL_BANNER_DISMISSED = 'shared_load_install_banner_dismissed',

    // Public pages a link into the mobile app lands on when the app did not open it (`/m/*`, `/invite/*`).
    // Properties: page, device, path_root (`mobileAppPathRoot`: a known first segment, else `other`). Never tokens, ids or query strings.
    MOBILE_LINK_PAGE_VIEWED = 'mobile_link_page_viewed',
    MOBILE_LINK_OPEN_APP_CLICKED = 'mobile_link_open_app_clicked',
    MOBILE_LINK_STORE_CLICKED = 'mobile_link_store_clicked',
    MOBILE_LINK_WEB_REDIRECTED = 'mobile_link_web_redirected',

    // AI Dispatch by text — the connect page (ADR-053): `step` (preview | confirm | decline),
    // `outcome` (shown | connected | declined | expired | taken | no_account | unavailable | error), `channel`.
    // Never the handle, the token or the account.
    MESSAGING_CONNECT_OUTCOME = 'messaging_connect_outcome',
    // AI Dispatch by text — the email-connect page (ADR-054): `step` (preview | start | connect), `outcome` (shown | started |
    // connected | cancelled | expired | limit | taken | unavailable | error), `provider` (google | microsoft). Never the
    // mailbox, the handle, the token or the account.
    MESSAGING_EMAIL_CONNECT_OUTCOME = 'messaging_email_connect_outcome',
}
